<div class="paging">
  <ul>
    <li class="prev" (click)="onClickPage(activePage - 1)">
      <span></span>
    </li>
    @for (page of pages; track page) {
      <li [ngClass]="{ current: page === activePage }" (click)="onClickPage(page)">
        <span>{{ page }}</span>
      </li>
    }
    <li class="next" (click)="onClickPage(activePage + 1)">
      <a>
        <span></span>
      </a>
    </li>
  </ul>
</div>
